<template>
  <div style="transition: 0.4s; box-shadow: 4px 8px 16px 4px rgba(135, 135, 135, 0.6); z-index: 9999;" class="w-1/4 flex-1 bg-white rounded-xl space-y-6 p-6" :class="`step${ nowStep }`">
    <img v-if="nowStep === 53" :src="require('@/assets/v1.png')" />
    <img v-if="nowStep === 54" :src="require('@/assets/v2.png')" />
    <img v-if="nowStep === 55" :src="require('@/assets/v3.png')" />
    <main class="slide-btn-frame" v-if="nowStep === 53 || nowStep === 54 || nowStep === 55">
      <button
        class="focus:outline-none rounded-xl px-4 py-1 transition duration-500 ease-in-out border-2"
        :class="nowStep === 54 || nowStep === 55 ? 'bg-blue-900 hover:bg-blue-900 text-white border-blue-900' : 'text-blue-400 border-blue-400'"
        @click="nowStep === 54 || nowStep === 55 ? back() : null"
      >
        {{ `<` }}
      </button>
      <button
        class="focus:outline-none rounded-xl px-4 py-1 transition duration-500 ease-in-out border-2"
        :class="nowStep === 53 || nowStep === 54 ? 'bg-blue-900 hover:bg-blue-900 text-white border-blue-900' : 'text-blue-400 border-blue-400'"
        @click="nowStep === 53 || nowStep === 54 ? next() : null"
      >
        {{ `>` }}
      </button>
    </main>
    <p v-html="content"></p>
    <div class="tip-footer">
      <button
        :style="{ opacity: nowStep === 51 ? 1 : 0 }"
        class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
        :disabled="nowStep > 1"
        @click="closeTips()"
      >
        {{closeTipsText}}
      </button>
      <button
        v-if="nowStep === 57"
        class="hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 text-blue-800 transition duration-500 ease-in-out border-yellow-400 border-2 bg-yellow-300"
        @click="next()"
      >
        {{finishText}}
      </button>
      <button
        v-else
        class="focus:outline-none rounded-xl px-4 py-1 transition duration-500 ease-in-out border-2"
        :class="nowStep === 53 || nowStep === 54 ? 'hover:bg-grey-400 bg-grey-400 border-grey-400 text-grey' : 'hover:bg-green-200 bg-green-400 border-green-400 text-white'"
        @click="next()"
        :style="{ opacity: nowStep === 56 ? 0 : 1 }"
        :disabled="nowStep === 53 || nowStep === 54 || nowStep === 56"
      >
        {{nextText}}
      </button>

    </div>
  </div>
</template>

<script>
import * as contentData from '@/components/Tips/materialTips.json';

export default {
  name: 'GoalsAndBudgetTips',
  props: {
    nowStep: {
      type: Number,
      default: 1
    },
    selectLang: {
      type: String
    }
  },
  data() {
    return {
      nextText: '下一步',
      finishText: '完成',
      closeTipsText: '跳過教學'
    }
  },
  computed: {
    content() {
      const data = contentData.default.filter(e => e.step === this.nowStep);
      let message;
      if (data.length > 0) {
        message = data[0].content_zh_TW;
        if(this.selectLang == 'zh-CN'){
          this.nextText = '下一步';
          this.finishText = '完成';
          this.closeTipsText = '跳过教学';

          message = data[0].content_zh_CN;
        }
        if(this.selectLang == 'en-US'){
          this.nextText = 'next';
          this.finishText = 'finish';
          this.closeTipsText = 'skip teaching';

          message = data[0].content_en_US;
        }
      } else {
        message = '';
      }
      return message;
    }
  },
  methods: {
    back() {
      this.$emit('backStep');
    },
    next() {
      this.$emit('nextStep');
      // this.nowStep = this.nowStep + 1;
    },
    closeTips() {
      this.$emit('closeTips');
    }
  }
};

</script>

<style lang="scss">

.slide-btn-frame {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
/*無效？*/
.tip-block {
  box-shadow: 4px 8px 16px 4px rgba(135, 135, 135, 0.6);
  z-index: 9999;
}

.step11001 {
  position: absolute;
  top: 50vh;
  left: 55vw;
}

.step11002 {
  position: absolute;
  top: 50vh;
  left: 55vw;
}

.step51 {
  position: absolute;
  top: 50vh;
  left: 55vw;
}

.step52 {
  position: absolute;
  top: 40vh;
  left: 55vw;
}

.step53 {
  position: absolute;
  /*top: 35vh;
  left: 55vw;*/
  top: 30vh;
  left: 40vw;
}

.step54 {
  position: absolute;
  /*top: 35vh;
  left: 55vw;*/
  top: 30vh;
  left: 40vw;
}

.step55 {
  position: absolute;
  /*top: 35vh;
  left: 55vw;*/
  top: 30vh;
  left: 40vw;
}

.step56 {
  position: absolute;
  top: 40vh;
  left: 75vw;
}

.step57 {
  position: absolute;
  top: 45vh;
  left: 50vw;
}

.step501 {
  position: absolute;
  top: 40vh;
  left: 55vw;
}

.step502 {
  position: absolute;
  top: 20vh;
  left: 65vw;
}

.step503 {
  position: absolute;
  top: 20vh;
  left: 65vw;
}

.tips-img {
  width: 800px;
}

.tip-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

</style>
